import PageHeader from '@/components/layout/PageHeader';
import React, { useEffect, useState } from 'react';
import ajax from '@/scripts/ajax';
import { Button, message, Input, Card, Form, Select, Col, Row, Table } from 'antd';
import { SEARCH_ITEM_COL, SEARCH_ITEM_GUTTER } from '@/scripts/config';
import dayjs from 'dayjs';

const pageKey = 'BookTempList'; //页面身份
export default function BookTempList() {
    const [dataSource, setState] = useState([]);
    const [formSearch] = Form.useForm();
    const [total, setTotal] = useState([]);
    const [pageSize, setSize] = useState([]);
    const [current, setCurrent] = useState([]);
    useEffect(() => {
        ajax.get('/maersk/book/list/temp')
            .then((response) => {
                setTotal(response.pagination.total);
                // 添加禁用状态 默认false
                const data = response.data.map((item, index) => {
                    item.update_time = item.update_time ? dayjs(item.update_time).format('YYYY-MM-DD HH:mm:ss') : null;
                    item.customer_code = item.customer_code ? item.customer_code : '';
                    item.id = index;
                    // item.is_refresh_use = item.is_refresh_use ? item.is_refresh_use : '';
                    if (item.is_refresh_use == 0) {
                        item.is_refresh_use = '否';
                    } else if (item.is_refresh_use == 1) {
                        item.is_refresh_use = '是';
                    } else {
                        item.is_refresh_use = '';
                    }
                    return item;
                });
                setState(data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const columns = [
        {
            title: '账号',
            dataIndex: 'account',
            align: 'center',
            width: 100,
            sorter: (a, b) => a['account'].localeCompare(b['account']),
        },
        {
            title: '密码',
            dataIndex: 'password',
            align: 'center',
            width: 100,
            sorter: (a, b) => a['password'].localeCompare(b['password']),
        },
        {
            title: '客户代码',
            dataIndex: 'customer_code',
            sorter: (a, b) => a['customer_code'].localeCompare(b['customer_code']),
            width: 200,
            align: 'center',
        },
        {
            title: '是否刷新使用',
            dataIndex: 'is_refresh_use',
            sorter: (a, b) => a['is_refresh_use'].localeCompare(b['is_refresh_use']),
            width: 100,
            align: 'center',
        },
        {
            title: '更新时间',
            dataIndex: 'update_time',
            align: 'center',
            width: 300,
            sorter: (a, b) => +new Date(a.update_time) - +new Date(b.update_time),
        },
    ];

    const renderSearch = (current, pageSize) => {
        let params = formSearch.getFieldsValue();
        if (params.account_type == '') {
            params.account_type = undefined;
        }
        params.per_page = pageSize;
        setSize(pageSize);
        params.page = current ? current : 1;
        setCurrent(params.page);
        ajax.get('maersk/book/list/temp', { params })
            .then((response) => {
                if (response) {
                    setTotal(response.pagination.total);
                    const data = response.data.map((item, index) => {
                        item.update_time = item.update_time ? dayjs(item.update_time).format('YYYY-MM-DD HH:mm:ss') : null;
                        item.customer_code = item.customer_code ? item.customer_code : '';
                        item.id = index;
                        if (item.is_refresh_use == 0) {
                            item.is_refresh_use = '否';
                        } else if (item.is_refresh_use == 1) {
                            item.is_refresh_use = '是';
                        } else {
                            item.is_refresh_use = '';
                        }
                        return item;
                    });
                    setState(data);
                } else if (response == undefined) {
                    setState(response);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    // 分页
    const onShowSizeChange = (row) => {
        renderSearch(row.current, row.pageSize);
        setCurrent(row.current);
    };

    return (
        <div className="list">
            <PageHeader title="小吴订舱账号列表" sticky></PageHeader>
            <Card style={{ width: '100%' }} className="ax-search-card">
                <Form form={formSearch} autoComplete="off">
                    <Row gutter={SEARCH_ITEM_GUTTER}>
                        <Col span={4}>
                            <Form.Item label="账号分组" name="account_type">
                                <Input></Input>
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <span>
                                <Button onClick={() => renderSearch()} type="primary">
                                    搜索
                                </Button>
                            </span>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Table
                className="List"
                rowKey={(record) => record.id}
                pagination={{
                    pageSizeOptions: [100, 200, 500],
                    total: total,
                    current: current,
                    showSizeChanger: true,
                    defaultPageSize: 100,
                }}
                onChange={onShowSizeChange}
                dataSource={dataSource}
                columns={columns}
            />
        </div>
    );
}
